import { CaArea, CaGroup, CaResult } from '../../core';

export function fillCaResultScores(
    groups: CaGroup[] | null /* CaConfig -> CaGroup */,
    result: CaResult,
): void {
    const configAreas: CaArea[] = [];
    groups?.forEach((e) => {
        if (e.areas != null) {
            configAreas.push(...e.areas);
        }
    });

    result.score = 0;

    result.groups?.forEach((g) => {
        g.score = 0;

        g.areas?.forEach((a) => {
            const ca = configAreas.find((e) => e.name === a.name);

            if (ca == null || ca.doNotEvaluate === true) {
                return;
            }

            a.score =
                (a.evaluatedBool === true
                    ? ca.maxScore /* CaConfig -> CaGroup -> CaArea -> Score */
                    : null) ?? 0;

            if (g.score != null) {
                g.score += a.score;
            }
        });

        if (g.areas != null) {
            g.scorePercent = (1 / g.areas?.length) * g.score;
        }

        if (result.score != null) {
            result.score += g.score;
        }
    });

    result.scorePercent = (1 / configAreas.length) * result.score;
}
